import { useEffect, useRef } from "react";
import { useNavigation } from "react-router";

export function LoadingBar() {
  const { state } = useNavigation();
  const ref = useRef<HTMLDivElement>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const bar = ref.current;
    if (!bar) return;

    if (state === "loading" || state === "submitting") {
      bar.style.width = "0%";
      bar.style.opacity = "1";
      // Animate to 80% quickly, hold until navigation completes
      requestAnimationFrame(() => {
        bar.style.transition = "width 300ms ease-out";
        bar.style.width = "80%";
      });
    } else {
      // Complete the bar, then hide
      bar.style.transition = "width 150ms ease-out";
      bar.style.width = "100%";
      timerRef.current = setTimeout(() => {
        bar.style.transition = "opacity 200ms ease-out";
        bar.style.opacity = "0";
      }, 150);
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [state]);

  return (
    <div className="pointer-events-none fixed left-0 right-0 top-0 z-50 h-[2px]">
      <div
        ref={ref}
        className="h-full bg-primary opacity-0"
        style={{ width: "0%" }}
      />
    </div>
  );
}
